import Feature1 from './Feature1'
export default Feature1
